import * as React from 'react'
import { classes } from 'typestyle'

/* Styles ======================================================================================= */
import { gridItemClass } from './grid-item.class'

/* Types ======================================================================================== */
type GridItemProps = { style?: React.CSSProperties; children?: any; className?: string }

/* <GridItem /> ================================================================================= */
const GridItemComponent: React.FC<GridItemProps> = props => {
  const { className, children, style } = props

  const { base } = gridItemClass.setProps({ isSpaced: true })

  return (
    <div className={classes('aeki-grid-item', base, className)} style={style}>
      {children}
    </div>
  )
}

/* Export ======================================================================================= */
export const GridItem = GridItemComponent
